import Polyline from "@arcgis/core/geometry/Polyline"
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import {textSymbol,line,polygon} from './symbols'
import Point from "@arcgis/core/geometry/Point";
import Graphic from "@arcgis/core/Graphic";

export const unitDict={feet:'ft',meters:'m',centimeters:'cm',kilometers:'km',miles:'mi',yards:'yds',inches:'in',acres:'ac'}

export const removefeatureLabelByFeatureId=(labelLayer,featureId)=>{
    let arr=labelLayer.graphics.filter((graphic:any)=>{
        return graphic.attributes.featureId===featureId// && graphic.attributes?.labelType===labelType
      }).toArray()
      labelLayer.removeMany(arr)
}

export const addLabelsToGeometry=(graphic,measurementLabelLayer,spatialReference,lengthUnit='feet',areaUnit='feet',dict=unitDict)=>{
   const{featureId,tool}=graphic.attributes
   let paths:any
   if(graphic.geometry?.paths){
      paths=graphic.geometry.paths[0]
   }
   if(graphic.geometry?.rings){
      paths=graphic.geometry.rings[0]
      let labelSymbol=textSymbol.clone();
      let area = Math.round(geometryEngine.planarArea(graphic.geometry)*100)/100
      area = convertMeasurement(area, 'feet', areaUnit,true)
      let radius=Math.round(geometryEngine.distance(graphic.geometry.centroid, new Point({ x: graphic.geometry.rings[0][graphic.geometry.rings[0].length - 1][0], y: graphic.geometry.rings[0][graphic.geometry.rings[0].length - 1][1], spatialReference: spatialReference }))*100)/100
      radius=convertMeasurement(radius, 'feet', lengthUnit)
      labelSymbol.text = `Area: ${area.toFixed(2)} ${dict[areaUnit]}\n ${tool === 'circle' ? `Radius: ${radius.toLocaleString()} ${dict[lengthUnit]}` : ''}`;
      let centerpoint=graphic.geometry.centroid.clone();
      let areaLabel=new Graphic({geometry:centerpoint,attributes:{"featureId":featureId},symbol:labelSymbol});
      measurementLabelLayer.add(areaLabel);
   }
   //const{paths}=graphic.geometry
   if(tool !=='circle'){
   for(let i=0;i<paths.length-1;i++){
      let labSymbol=textSymbol.clone();
      let lineGeometry = new Polyline({paths:[paths[i],paths[i+1]],spatialReference:spatialReference});
      let lineDist=Math.round(geometryEngine.planarLength(lineGeometry)*100)/100;
      lineDist=convertMeasurement(lineDist, 'feet', lengthUnit)
      labSymbol.text=`${lineDist.toLocaleString()} ${dict[lengthUnit]}`;
       let MidPointGeom=new Point({x:(paths[i+1][0]+paths[i][0])/2,y:(paths[i+1][1]+paths[i][1])/2,spatialReference:spatialReference})
       let label=new Graphic({geometry:MidPointGeom,symbol:labSymbol,attributes:{"featureId":featureId}});
       measurementLabelLayer.add(label);
    }
    let lastPoint=new Point({x:paths[paths.length-1][0],y:paths[paths.length-1][1],spatialReference:spatialReference})
    let symbol=textSymbol.clone()
    let totalDistance=Math.round(geometryEngine.planarLength(graphic.geometry)*100)/100
    totalDistance=convertMeasurement(totalDistance, 'feet', lengthUnit)
    symbol.text=`Total distance: ${totalDistance.toLocaleString()} ${dict[lengthUnit]}`
    let newGraphic=new Graphic({geometry:lastPoint,symbol:symbol,attributes:{"featureId":featureId}})
  measurementLabelLayer.add(newGraphic)
   }
}

   //Compute bearing.
   export function getBearing(pnt1, pnt2) {
   let beg: string;
   let end: string;
   let bear: number;

   const xD: number = pnt1.x - pnt2.x;
   const yD: number = pnt1.y - pnt2.y;

   if ((Math.abs(xD) < 1) && (Math.abs(yD) < 1)) {
      return "";
   }
   const rad: number = Math.atan2(yD, xD);
   const deg: number = rad * (180 / Math.PI) + 90;
   end = "E";

   if (deg > -90 && deg <= 90) {
      beg = "N";
      if (deg > 0) {
         end = "W";
      }
      bear = Math.abs(deg);

   } else {
      beg = "S";
      if (deg < 180) {
         end = "W";
      }
      bear = Math.abs(180 - deg);
   }
   const dms: string = ddToDMS(bear, true, false);
   return beg + dms + end;
}

 //DD to DMS.
 export function ddToDMS(dd: number, addZero: boolean, addDecimal: boolean): string {
  const d: number = parseInteger(dd.toString());
  const dF: number = Math.abs(dd - d);
  const m: number = parseInteger((dF * 60).toString());
  let s: number = dF * 3600 - m * 60;
  let deg: string = d.toString();
  let minute: string = m.toString();

  if (addDecimal) {
     const u: number = 10;
     s = parseInteger((s * u + (5 / 10)).toString()) / u;
  } else {
     s = Math.round(s);
  }
  let sec: string = s.toString();

  if (addZero) {
     if (d < 10) {
        deg = "0" + d;
     }
     if (m < 10) {
        minute = "0" + m;
     }
     if (s < 10) {
        sec = "0" + s;
     }
  }
  const dms: string = deg + '\xB0 ' + minute + '\' ' + sec + '"';
  return dms;
}

   //Parse integer.
   export function parseInteger(str: string): number {
    let outVal: number = parseInt(str, 10);
    if (isNaN(outVal)) {
       outVal = 0;
    }
    return outVal;
 }

 export function convertMeasurement(value, sourceUnit, targetUnit, isArea = false) {
   // Define conversion factors for length and area units
   const lengthConversion = {
     feet: 1,
     meters: 0.3048,
     kilometers: 0.0003048,
     miles: 1 / 5280,
     yards: 1 / 3,
     inches: 12,
     centimeters: 30.48,
   };
 
   const areaConversion = {
     feet: 1,
     meters: 0.092903,
     kilometers: 9.2903e-8,
     miles: 3.587e-8,
     yards: 1/9,
     acres: 1/43560,
     inches: 144,      // 1 square foot is 144 square inches
     centimeters: 929.03,  // 1 square foot is 929.03 square centimeters
   };
 
   // Check if it's a length or area conversion
   const conversionTable = isArea ? areaConversion : lengthConversion;
 
   // Check if the source and target units are valid
   if (!conversionTable[targetUnit] || !conversionTable[sourceUnit]) {
     throw new Error('Invalid source or target unit');
   }
 
   // Perform the conversion
   const convertedValue = (value * conversionTable[targetUnit]) / conversionTable[sourceUnit];
 
   return convertedValue;
 }